import { render, staticRenderFns } from "./ResumeTemplatesSection.vue?vue&type=template&id=c24c5acc&scoped=true"
import script from "./ResumeTemplatesSection.vue?vue&type=script&lang=js"
export * from "./ResumeTemplatesSection.vue?vue&type=script&lang=js"
import style0 from "./ResumeTemplatesSection.vue?vue&type=style&index=0&id=c24c5acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24c5acc",
  null
  
)

export default component.exports